import { render, staticRenderFns } from "./setGroup.vue?vue&type=template&id=6449b2fa"
import script from "./setGroup.vue?vue&type=script&lang=js"
export * from "./setGroup.vue?vue&type=script&lang=js"
import style0 from "./setGroup.vue?vue&type=style&index=0&id=6449b2fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports